import readStored from './readStored';

/**
 * Function to set the default value to filters and sorting at CustomersList mount and on change when no filters values are setted.
 * The function accepts an array of objects ({ keyName, defaultValue}) and checks in localStorage if the keyName is present, otherwise it sets the value to default or null if not provided.
 * Returns an object with the provided keyNames and their values.
 *
 * @param {Array} filterKeys - Array. Each element must be an object like ({ keyName: [String], defaultValue: [any] }).
 *
 * @returns {Object} The filters object.
 */

export default (filtersKeys = []) =>
  Object.fromEntries(
    filtersKeys.map(({ keyName, defaultValue }) => [
      keyName,
      readStored(keyName) ?? (defaultValue || null),
    ])
  );
